var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.013 2.63759H6.33333C6.70167 2.63759 7 2.93593 7 3.30426V6.33259C7 6.69926 6.7 6.99926 6.33333 6.99926H1.66667C1.29833 6.99926 1 6.70093 1 6.33259V2.76293C1 2.48559 1.17167 2.23726 1.43133 2.13926L4.88233 0.836261C5.10033 0.753927 5.33333 0.914927 5.33333 1.14793V2.63726",
    stroke: "#a0aec0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33235 4.70768C5.26335 4.70801 5.20768 4.76401 5.20768 4.83301C5.20768 4.90201 5.26368 4.95801 5.33268 4.95768C5.40168 4.95768 5.45768 4.90168 5.45768 4.83268C5.45768 4.76368 5.40168 4.70768 5.33235 4.70768",
    stroke: "#a0aec0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.d4f0b5252adfc576c6c63a0dac7733aa.svg";
export { ForwardRef as ReactComponent };